export const getOrdinalNumber = (number) => {
  if (number < 1) {
    return "Invalid input";
  }

  const suffixes = ["th", "st", "nd", "rd"];
  const lastDigit = number % 10;
  const secondLastDigit = Math.floor((number % 100) / 10);

  if (secondLastDigit === 1 || lastDigit >= 4 || lastDigit === 0) {
    return number + "th";
  }

  return number + suffixes[lastDigit];
};
